export enum State {
  DISABLE = 0,
  ENABLE,
}

export const StatusDisplay = {
  [State.DISABLE]: '禁用',
  [State.ENABLE]: '启用',
};
